import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0),
    },
  },
  title: {
    display: "inline-flex",
    justifyContent: "space-between",
    margin: theme.spacing(2),
  },
  previewChip: {
    fullWidth: true,
  },
  dropboxContainer: {
    marginLeft: "25%",
    marginRight: "25%",
    width: "100%",
  },
  getHistoryBtn: {
    marginLeft: "16px",
  },
  submitBtn: {
    float: "right",
    top: 0,
    margin: theme.spacing(1),
  },
  gridRow: {
    width: "100%",
  },
  errorBox: {
    [theme.breakpoints.down("lg")]: {
      marginLeft: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: "0%",
    },
    marginRight: "20%",
    marginTop: theme.spacing(1),
    width: "80%",
    textAlign: "justify",
  },
  tableContainer: {
    width: "100%",
    margin: theme.spacing(2),
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
  },
  icon: {
    color: "primary",
  },
  error: {
    color: "red",
  },
  progressContainer: {
    // Span the same width as the title/description above and the history table below (full width with
    // the standard spacing(2) inset) so the in-progress card lines up with the rest of the page rather
    // than being pinned to a narrower column. Outlined Paper + primary left accent per the design system.
    margin: theme.spacing(2),
    width: `calc(100% - ${theme.spacing(4)}px)`,
    padding: theme.spacing(2),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  progressBar: {
    height: 10,
    borderRadius: 8,
  },
  progressCounts: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
  },
  cancelBtn: {
    marginTop: theme.spacing(1),
  },
  blockedBox: {
    // Match progressContainer's alignment (full width with the standard spacing(2) inset) so the
    // blocked-by-another-user card lines up with the page content and history table.
    margin: theme.spacing(2),
    width: `calc(100% - ${theme.spacing(4)}px)`,
    padding: theme.spacing(2),
    borderLeft: `4px solid ${theme.palette.error.main}`,
  },
  blockedTitle: {
    color: theme.palette.error.main,
  },
}));
